import HelpGenieLogo from "@/components/ui/HelpGenieLogo";

/**
 * "Made magical by Help Genie" footer — only in embed mode, and only when
 * the tenant hasn't hidden attribution via branding.
 */
export interface EmbedAttributionFooterProps {
  isEmbedMode: boolean;
  hideAttribution?: boolean;
  brand: string;
  studioUrl: string;
}

export function EmbedAttributionFooter({
  isEmbedMode,
  hideAttribution,
  brand,
  studioUrl,
}: EmbedAttributionFooterProps) {
  if (!isEmbedMode || hideAttribution) return null;

  return (
    <div
      style={{
        marginTop: 12,
        padding: "10px 16px",
        borderTop: "1px solid #E5E7EB",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        flexShrink: 0,
      }}
    >
      <HelpGenieLogo size={18} />
      <a
        href={studioUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          fontSize: "12px",
          fontWeight: 400,
          color: brand,
          textDecoration: "none",
          transition: "opacity 0.2s",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.opacity = "0.7";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.opacity = "1";
        }}
      >
        Made magical by Help Genie
      </a>
    </div>
  );
}

export default EmbedAttributionFooter;
